import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import React, {useState} from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom';
import CoBrandTable from '../CoBrandTable';

const SelectCoBrand = () => {
    const [selectedCoBrand, setSelectedCoBrand] = useState(undefined);
    const history = useHistory();
    let { url } = useRouteMatch();

    
    const [{ data: coBrands, loading }, refetch] = useAxios("internal/cobrand/hubsettings");

    if (loading)
        return <Spinner className="absolute-center" label="Loading Cobrand Hub Settings..." />;

    return (
        <>
            <CoBrandTable
                cobrands={coBrands && coBrands.length > 0 ? coBrands.sort((a, b) => b.coBrandID - a.coBrandID) : []}
                setSelectedCoBrand={setSelectedCoBrand}
                selectedCoBrand={selectedCoBrand}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                refetch={refetch}
                loading={loading}
            />
           
        </>
    );
}

export default SelectCoBrand